export { Cache } from './cache-decorator/cache.decorator';
export { staticImplements } from './static-implements';
